import { Link } from 'react-router-dom';

export function NotFoundPage(): JSX.Element {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-3 text-center">
      <p className="text-fg-muted">გვერდი ვერ მოიძებნა</p>
      <Link to="/" className="text-primary underline">
        მთავარზე დაბრუნება
      </Link>
    </div>
  );
}
